import { Rule } from 'antd/lib/form'

export const API_URL = 'https://api.innovationx.ai/'
export const BASE_URL = 'https://dev.innovationx.ai'
// export const API_URL = 'http://localhost:3030/'
// export const BASE_URL = 'http://localhost:3000'

export enum SUBSCRIPTION {
    FREE = 'Free',
    SOLO = 'Solo',
}

export enum STORAGE_KEYS {
    ID = 'uID',
    ACCESS = 'aToken',
    REFRESH = 'rToken',
}

export const emailRules: Rule[] = [
    {
        type: 'email',
        message: 'E-mail is incorrect',
    },
    {
        required: true,
        message: 'E-mail is required',
    },
]

export const passwordRules: Rule[] = [
    {
        required: true,
        message: 'Password is required',
    },
    {
        pattern:
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
        message:
            'Password must contain minimum 8 characters, letters, numbers and special character',
    },
]

export const STRIPE_PUBLISH_KEY = {
    DEV: 'pk_test_51KpzMBLOwPOkv4fdjVKzmPODQr4dYnqzYxMCSH8BIyf00cqxPyQRbehAhDRPqeTVH8c4gIoMPSkuI26rboW6wcpb006i6hteIP',
    PROD: '',
}
